import PropTypes from 'prop-types';

const VolunteeringOpportunityModel = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  nonProfitId: PropTypes.number.isRequired,
  imageUrls: PropTypes.arrayOf(PropTypes.string),
  videoUrls: PropTypes.arrayOf(PropTypes.string),
  nonProfit: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    logo_url: PropTypes.string,
  }).isRequired,
  startsOn: PropTypes.string.isRequired,
  applyDeadline: PropTypes.string,
  endsOn: PropTypes.string.isRequired,
  startsAt: PropTypes.string,
  endsAt: PropTypes.string,
  location: PropTypes.string.isRequired,
  estimatedBillRate: PropTypes.number.isRequired,
  timeCommitmentMin: PropTypes.number,
  timeCommitmentMax: PropTypes.number,
  volunteersReq: PropTypes.number.isRequired,
  type: PropTypes.oneOf(['flexible', 'one-time-event']).isRequired,
  additionalDetails: PropTypes.string,
  virtual: PropTypes.bool.isRequired,
  postId: PropTypes.string.isRequired,
  userVolunteeringInfo: PropTypes.shape({
    status: PropTypes.oneOf([
      'pending',
      'active',
      'completed',
      'rejected',
      'onhold',
      'none',
    ]).isRequired,
  }),
});

export default VolunteeringOpportunityModel;
